import type { ClientOptions, StackFrame } from "@sentry/types";
import { getFramesFromEvent } from "@sentry/utils";

const THIRD_PARTY_DOMAINS = [
  "https://cdn.cookielaw.org",
  "https://consent.cookiebot.com",
  "https://script.crazyegg.com",
  "https://www.googletagmanager.com",
  "https://www.gstatic.com",
  "https://js.adsrvr.org",
  "https://static.ada.support",
];

const doesStacktraceContainThirdPartyDomain = (stacktrace: StackFrame[] | undefined) => {
  if (!stacktrace) return false;

  return stacktrace.some(frame =>
    THIRD_PARTY_DOMAINS.some(
      domain => frame.filename?.startsWith(domain) || frame.abs_path?.startsWith(domain)
    )
  );
};

const thirdPartyDomains: NonNullable<ClientOptions["beforeSend"]> = event => {
  const frames = getFramesFromEvent(event);

  if (doesStacktraceContainThirdPartyDomain(frames)) {
    return null;
  }

  return event;
};

export { thirdPartyDomains };
